// src/components/SectionGroup.jsx
import React from "react";
import SectionCard from "./SectionCard";
import "./SectionGroup.css"; // 根据需求定制分组样式

const SectionGroup = ({ category, items }) => {
    return (
        <section className="section-group">
            <h2 className="section-group-title">{category}</h2>
            <div className="section-group-content">
                {items.map((item, index) => (
                    <SectionCard
                        key={index}
                        title={item.title}
                        descriptions={item.descriptions}
                    />
                ))}
            </div>
        </section>
    );

};

export default SectionGroup;
